import './polyfill';
import React from 'react'; //eslint-disable-line
import ReactDOM from 'react-dom';
import './i18n';
import App from './App'; //eslint-disable-line
import { unregister } from './registerServiceWorker';
import { Provider } from 'react-redux'; //eslint-disable-line
import store from "./redux/store";
import './App.scss';

unregister();

ReactDOM.render(
    <Provider store={store} >
        <App />
    </Provider>,
    document.getElementById('root')
);